import { useRegisterSW } from 'virtual:pwa-register/react';
import { RefreshCw } from 'lucide-react';
import { Button } from '../ui/button.js';

/**
 * New version available.
 *
 * We ask rather than auto-reloading (`registerType: 'prompt'`). Swapping the app
 * out from under someone who is halfway through a mould form would throw away
 * their typing - and this app is used by people entering long spec sheets.
 */
export function UpdatePrompt() {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW();

  if (!needRefresh) return null;

  return (
    <div
      role="status"
      className="safe-b fixed inset-x-3 bottom-20 z-40 mx-auto flex max-w-md items-center gap-3 rounded-xl border border-border bg-surface-raised px-4 py-3 shadow-lg lg:bottom-4"
    >
      <RefreshCw className="size-4 shrink-0 text-primary" aria-hidden />
      <p className="min-w-0 flex-1 text-sm">
        <span className="font-medium">A new version is ready.</span>{' '}
        <span className="text-muted-foreground">Your unsaved work stays on this device.</span>
      </p>
      <Button variant="ghost" size="sm" onClick={() => setNeedRefresh(false)}>
        Later
      </Button>
      <Button variant="primary" size="sm" onClick={() => void updateServiceWorker(true)}>
        Reload
      </Button>
    </div>
  );
}
